import { List, Stack, Text } from "@mantine/core"
import { Checkbox, InfoBox } from "@tfg/ui"
import React from "react"
import { useTranslation } from "react-i18next"

import { VerifyRawOperationsFileResponseDto } from "~/gen/api"
import { OperationsFileZone } from "~/pages/Brand/Products/List/Components/LaunchTraceabilityModal/OperationsFileZone"
import { RawOperationsFileError } from "~/pages/Brand/Products/List/Components/LaunchTraceabilityModal/utils"

export type EligibleProductsInfoBoxContentProps = {
  message: string
  onFileChange: (file: File) => void
  rawOperationsFileErrors: RawOperationsFileError[]
  loading: boolean
  setRawOperationsFileErrors: React.Dispatch<
    React.SetStateAction<RawOperationsFileError[]>
  >
  setRawOperationsChecked: React.Dispatch<React.SetStateAction<boolean>>
  rawOperationsChecked: boolean
  rawOperationsUploadedFile: VerifyRawOperationsFileResponseDto | undefined
  setRawOperationsUploadedFile: React.Dispatch<
    React.SetStateAction<VerifyRawOperationsFileResponseDto | undefined>
  >
}

export const EligibleProductsInfoBoxContent: React.FC<
  EligibleProductsInfoBoxContentProps
> = ({
  message,
  rawOperationsFileErrors,
  loading,
  rawOperationsChecked,
  rawOperationsUploadedFile,
  setRawOperationsFileErrors,
  setRawOperationsChecked,
  onFileChange,
  setRawOperationsUploadedFile,
}) => {
  const { t } = useTranslation("traceability")

  return (
    <Stack>
      <Text>{message}</Text>
      <Checkbox
        checked={rawOperationsChecked}
        label={t("launch.modal.eligibleProducts.checkbox")}
        onChange={(event) => {
          const newChecked = event.currentTarget.checked
          setRawOperationsChecked(newChecked)
          if (!newChecked) {
            setRawOperationsFileErrors([])
          }
        }}
        mt="sm"
      />
      <OperationsFileZone
        onFileChange={onFileChange}
        loading={loading}
        rawOperationsChecked={rawOperationsChecked}
        rawOperationsUploadedFile={rawOperationsUploadedFile}
        setRawOperationsUploadedFile={setRawOperationsUploadedFile}
      />
      {rawOperationsFileErrors.length > 0 && rawOperationsChecked ? (
        <InfoBox
          title={t("launch.modal.eligibleProducts.error.title")}
          message={
            <List spacing={0}>
              {rawOperationsFileErrors.map((error, index) => (
                <List.Item key={`${error.type}-${index}`}>
                  <Stack gap={0}>
                    <Text c="red" fw={700}>
                      {error.type}
                    </Text>
                    <Text>{error.lines}</Text>
                  </Stack>
                </List.Item>
              ))}
            </List>
          }
          variant="error"
          bg="var(--mantine-color-white)"
        />
      ) : null}
    </Stack>
  )
}
